import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@atlaskit/css-reset';
import './index.css';
import { setGlobalTheme } from '@atlaskit/tokens';

setGlobalTheme({
  colorMode: 'auto',
  light: 'light',
  dark: 'dark',
  spacing: 'spacing',
});

ReactDOM.render(<App />, document.getElementById('root'));
